import { aiChatEffort, aiChatModel } from 'shared/constants.json';

export const aiChatModelNames = {
  [aiChatModel.gpt5Mini]: 'GPT-5 mini',
  [aiChatModel.gpt5]: 'GPT-5',
  [aiChatModel.claudeHaiku45]: 'Claude Haiku 4.5',
  [aiChatModel.claudeSonnet5]: 'Claude Sonnet 5',
  [aiChatModel.claudeOpus5]: 'Claude Opus 5',
  [aiChatModel.mistralSmall4]: 'Mistral Small 4',
  [aiChatModel.mistralMedium35]: 'Mistral Medium 3.5',
  [aiChatModel.mistralLarge4]: 'Mistral Large 4',
};

const mistralModels = [aiChatModel.mistralSmall4, aiChatModel.mistralMedium35, aiChatModel.mistralLarge4];

// mirrors brainstorm's app.yaml catalog: haiku 4.5's API rejects any effort, and Mistral Small
// and Medium accept only "high" (unset sends no reasoning_effort, their default)
export const effortsFor = (model) => {
  switch (model) {
    case aiChatModel.claudeHaiku45:
      return [];
    case aiChatModel.mistralSmall4:
    case aiChatModel.mistralMedium35:
      return [aiChatEffort.high];
    default:
      return aiChatEffort.all;
  }
};

// mirrors brainstorm's mistral adapter, which never searches: Mistral offers web search only
// through its Agents API, not the Chat Completions endpoint the adapter speaks
export const supportsWebSearch = (model) => !mistralModels.includes(model);
